import { Pipe, PipeTransform } from '@angular/core';

// Epochs
const epochs: any = [
    ['year', 31536000],
    ['month', 2592000],
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
    ['second', 1]
];

// Short format mappings
const shortFormats: any = {
    'year': 'y',
    'month': 'mo',
    'day': 'd',
    'hour': 'h',
    'minute': 'm',
    'second': 's'
};

/*
 * Turn Date into realtive date (e.g. 5 days ago)
 * Usage:
 *   value | relativeDate
 *   value | relativeDate:true (short format)
 * Example:
 *   {{ 86400 |  relativeDate}}
 *   formats to: '1 day ago'
 *   {{ 86400 |  relativeDate:true}}
 *   formats to: '1d ago'
*/
@Pipe({ name: 'relativeDate' })
export class RelativeDatePipe implements PipeTransform {

    getDuration(timeAgoInSeconds: number) {
        for (let [name, seconds] of epochs) {
            let interval = Math.floor(timeAgoInSeconds / seconds);

            if (interval >= 1) {
                return {
                    interval: interval,
                    epoch: name
                };
            }
        }
        return {
            interval: 0,
            epoch: 'second'
        };
    };

    transform(dateStamp: any, shortFormat: boolean = false): string {
        if (dateStamp) {

            // Only append UTC marker when no explicit timezone suffix is present.
            const hasTimezoneSuffix = typeof dateStamp === 'string' && /(Z|[+-]\d{2}:?\d{2})$/i.test(dateStamp);
            if (typeof dateStamp === 'string' && !hasTimezoneSuffix) {
                dateStamp += 'Z';
            }

            var date = new Date(Date.parse(dateStamp));
            //var date = new Date(dateStamp);
            //console.log('date', date, dateStamp);
            if (date >= new Date()){
                // if in the future
                let timeSeconds = Math.floor((new Date(dateStamp).getTime() - new Date().getTime()) / 1000);
                let { interval, epoch } = this.getDuration(timeSeconds);
                
                if (shortFormat) {
                    return `${interval}${shortFormats[epoch]}`;
                } else {
                    let suffix = interval === 1 ? '' : 's';
                    return `${interval} ${epoch}${suffix}`;
                }
            } else {
                let timeAgoInSeconds = Math.floor((new Date().getTime() - new Date(dateStamp).getTime()) / 1000);
                let { interval, epoch } = this.getDuration(timeAgoInSeconds);
                
                if (shortFormat) {
                    return `${interval}${shortFormats[epoch]} ago`;
                } else {
                    let suffix = interval === 1 ? '' : 's';
                    return `${interval} ${epoch}${suffix} ago`;
                }
            }
        }
        return '';
    }

}
